export type CallCardBounds = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export function shouldUseChannelAsCallCardLayoutTarget({
  callChannelId,
  channelId,
  expanded,
}: {
  callChannelId: string | undefined;
  channelId: string;
  expanded: boolean;
}) {
  return expanded || !callChannelId || callChannelId === channelId;
}

export function getInlineCallCardStyle(bounds: CallCardBounds) {
  return {
    height: `${bounds.height}px`,
    transform: `translate(${bounds.x}px, ${bounds.y}px)`,
    width: `${bounds.width}px`,
  };
}
